<div [attr.data-theme]="'dark'">
  <div class="top-panel" >
    <div class="brand">
      <div class="icon-settings">
          <img
            style="width: 30ox; height: 30px;"
            src="../../../../../assets/img/image-edit.png"
            alt=""
            class="as-icons-menu"
          />
          <div class="set-content">Slider</div>
      </div>
       <div class="setting">
        <img
        style="width: 30ox; height: 30px;"
          src="../../../../../assets/icons/settings.svg"
          alt=""
          class="as-icons-menu"
        />
        <div class="set-content">{{'creator.changeSlideTemplate' | translate}}</div>  
       </div>
      </div>
       <div class="lang-wrapper">
        <as-app-button-toggle
          [lang]="currentLang"
          [languages]="languages"
          (languageSelect)="onLanguageSelect($event)">
        </as-app-button-toggle>
      </div>
      <div class="top-panel">
      <span class="spacer"></span>
      <as-button
        [useSubmitBehavior]="true"
        [size]="btnSize.Large"
        [variant]="btnVariant.Tertiary"
        (click)="cancel()"
        [label]="'creator.cancelButton' | translate"
        [customClass]="'w-100'"
      ></as-button>

      <as-button
        [useSubmitBehavior]="true"
        [size]="btnSize.Special"
        [variant]="btnVariant.DarkStyle"
        (click)="save()"
        [label]="'creator.saveButton' | translate"
        [customClass]="'w-100'"
      ></as-button>
    </div>
  </div>
  <div class="block-multiselect">

      <div class="block-select">
        <div class="block-lable">{{'creator.typeSlider' | translate}}</div>
        <as-multiselect
          [multiple]="false"
          name="typeSlider"    
          (valueModelChange)="settingsParams.sliderType = $event"
          [valueModel]="settingsParams.sliderType "
          [options]="typeSlider"
          language="pl"
        ></as-multiselect>
      </div> 
      <div class="block-select">
        <div class="block-lable">{{'creator.animationSlider' | translate}}</div>
        <as-multiselect
          [multiple]="false"
          name="typeSlider"    
          (valueModel)="settingsParams.animationType= $event"
          [valueModel]="settingsParams.animationType"
          [options]="animationSlider"
          language="pl"
        ></as-multiselect>
      </div>
      <div class="block-select">
        <as-input 
          placeholder="Np.5 | sec" 
          [(ngModel)]="settingsParams.animationDelay"
          [label]="'creator.anumationSliderTime' | translate"
          type="number"
          size="medium"
          >
        </as-input>
      </div>
      <div class="block-select">
        <as-input 
          placeholder="Np.5 | sec" 
          [(ngModel)]="settingsParams.animationDuration" 
          [label]="'creator.anumationSliderTimeOut' | translate"
          type="number"
          size="medium"
          >
        </as-input>
      </div>     
  </div>
  <div style="margin-left: 24px;">Edycja Slajdów</div>
  <div class="slider-edit-container"
      cdkDropList
      [cdkDropListData]="slides"
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="dropSlide($event)"
      >
    <div class="slide-block" 
        *ngFor="let slide of slides; index as i"
        cdkDrag
         [class.selected]="selectedSlideIndex === i"
         >

      <ng-template cdkDragPreview>
        <div class="drag-preview">
          <div class="slide-drag">{{ i + 1 }}</div>
        </div>
      </ng-template>
      <ng-template cdkDragPlaceholder>
        <div class="slide-block drag-placeholder"></div>
      </ng-template>
      <div class="slide-img" (click)="selectSlide(slide, i)">{{i+1}}</div>
      <div class="slide-actions">

        <button class="slide-btn" (click)="previewSlide(slide)" title="Podgląd">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C15.76 17.5 19.17 15.36 20.82 12C19.17 8.64 15.76 6.5 12 6.5C8.24 6.5 4.83 8.64 3.18 12Z" fill="#1A1A1A"/>
          </svg>
          <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 5.27L3.28 4L20 20.72L18.73 22L15.65 18.92C14.5 19.3 13.28 19.5 12 19.5C7 19.5 2.73 16.39 1 12C1.69 10.24 2.79 8.69 4.19 7.46L2 5.27ZM12 9C12.7956 9 13.5587 9.31607 
          14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.35 14.94 12.69 14.83 13L11 9.17C11.31 9.06 11.65 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C22.18 14.08 20.79 15.88 19 17.19L17.58 
          15.76C18.94 14.82 20.06 13.54 20.82 12C19.17 8.64 15.76 6.5 12 6.5C10.91 6.5 9.84 6.68 8.84 7L7.3 5.47C8.74 4.85 10.33 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C12.69 17.5 13.37 
          17.43 14 17.29L11.72 15C10.29 14.85 9.15 13.71 9 12.28L5.6 8.87C4.61 9.72 3.78 10.78 3.18 12Z" fill="#1A1A1A"/>
          </svg> -->

        </button>
        <!-- Kopiuj -->
        <button class="slide-btn" (click)="copySlide(i)" title="Kopiuj">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21H8V7H19V21ZM19 5H8C7.46957 5 6.96086 5.21071 6.58579 5.58579C6.21071 5.96086 6 6.46957 6 7V21C6 21.5304 6.21071 22.0391 6.58579 22.4142C6.96086 
            22.7893 7.46957 23 8 23H19C19.5304 23 20.0391 22.7893 20.4142 22.4142C20.7893 22.0391 21 21.5304 21 21V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 
            5.21071 19.5304 5 19 5ZM16 1H4C3.46957 1 2.96086 1.21071 2.58579 1.58579C2.21071 1.96086 2 2.46957 2 3V17H4V3H16V1Z" fill="#1A1A1A"/>
          </svg>

        </button>
        <!-- Usuń -->
        <button class="slide-btn" (click)="removeSlide(i)" title="Usuń">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 
          19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" fill="#1A1A1A"/>
          </svg>

        </button>
      </div>
    </div>
    <!-- Dodaj nowy slajd -->
    <button class="slide-block add-slide" (click)="addSlide()">
      <div class="add-slide-text">+ Dodaj nowy slajd</div>
    </button>
  </div>
</div>

<div class="block-slider" (click)="handleTextClick($event)"> 
  <!-- <div #editable [innerHTML]="selectBlochSlider"></div> -->
   <dynamic-host appEditableText [html]="selectBlochSlider"></dynamic-host>
  <div class="edit-btn-wrapper">
    <div class="edit-btn-block">
        <input #changeImgInput type="file" accept="image/*" hidden (change)="replaceImage(changeImgInput.files!)" />
        <button class="edit-btn" (click)="changeImgInput.click(); $event.stopPropagation(); $event.preventDefault();">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path fill="#fff" d="M19.6 4.34a2.13 2.13 0 0 0-3 0l-9.19 9.19a2 2 0 0 0-.53.93l-1.07 4.28a1 1 0 0 0 1.21 1.21l4.28-1.07a2 2 0 0 0 .93-.53l9.19-9.19a2.13 2.13 0 0 0 0-3Zm-9.27 10.27-2.23.56.56-2.23 6.84-6.84 1.67 1.67-6.84 6.84Zm8.1-8.09 1.09 1.09a.13.13 0 0 1 0 .18l-.88.88-1.27-1.27.88-.88a.13.13 0 0 1 .18 0Z"/>
        </svg>
      <img src="assets/icons/image.svg" alt="" (change)="replaceImage(changeImgInput.files!)" />{{'creator.uploudeImageSlider' | translate}}
    </button>
    </div>
    <div class="edit-btn-block">
      <button class="edit-btn" (click)="openBackgroundColorEditor()">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path fill="#fff" d="M19.6 4.34a2.13 2.13 0 0 0-3 0l-9.19 9.19a2 2 0 0 0-.53.93l-1.07 4.28a1 1 0 0 0 1.21 1.21l4.28-1.07a2 2 0 0 0 .93-.53l9.19-9.19a2.13 2.13 0 0 0 0-3Zm-9.27 10.27-2.23.56.56-2.23 6.84-6.84 1.67 1.67-6.84 6.84Zm8.1-8.09 1.09 1.09a.13.13 0 0 1 0 .18l-.88.88-1.27-1.27.88-.88a.13.13 0 0 1 .18 0Z"/>
        </svg>
        {{ 'creator.uploudeBackgroundColorSlider' | translate }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="editorVisible"
     class="text-editor"
     [ngStyle]="{ top: editorTop + 'px',
                  left: editorLeft + 'px',
                  transform: 'translate(-50%,-100%)' }"
     (mousedown)="$event.stopPropagation()"> bbvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvdssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss
  <app-inline-text-editor-component
      [valueType]="'HTMLElement'"
      [value]="editTarget"
      (save)="onContentSaved($event)"
      (cancelModal)="hideEditor()">
  </app-inline-text-editor-component>
</div>

 
 
